import UnauthorizedError from "../errors/UnauthorizedError";

class BaseApiService {
  _host = process.env.API_HOST;
  _namespace = "";

  async get(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "GET",
        ...opts,
      },
      headers
    );
  }
  async head(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "HEAD",
        ...opts,
      },
      headers
    );
  }
  async post(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "POST",
        ...opts,
      },
      headers
    );
  }
  async put(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "PUT",
        ...opts,
      },
      headers
    );
  }
  async delete(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "DELETE",
        ...opts,
      },
      headers
    );
  }
  async connect(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "CONNECT",
        ...opts,
      },
      headers
    );
  }
  async options(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "OPTIONS",
        ...opts,
      },
      headers
    );
  }
  async trace(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "TRACE",
        ...opts,
      },
      headers
    );
  }
  async patch(path, opts = {}, headers = {}) {
    return this.fetch(
      path,
      {
        method: "PATCH",
        ...opts,
      },
      headers
    );
  }

  async fetch(path, opts = {}, headers = {}) {
    try {
      const response = await fetch(`${this._host}${this._namespace}${path}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...headers,
        },
        ...opts,
      });

      if (response.status === 401) {
        localStorage.removeItem("access_token");
        if (window.location.pathname !== "/login") {
          window.location.replace("/login");
        }
        throw new UnauthorizedError(
          `Failed with http status code: ${response.status}, ${response.statusText}`
        );
      }
      if (!response.ok) {
        throw new Error(
          `Failed with http status code: ${response.status}, ${response.statusText}`
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
}

export default BaseApiService;
